// @ts-nocheck
export enum entitiesNames {
  timeline = "tsadv_Timeline",
  individualDevelopmentPlan = "tsadv$IndividualDevelopmentPlan",
  assigmentEXT = "base$AssignmentExt",
  learningBudgetRequest = "tsadv_LearningBudgetRequest",
  learningBudgetRequestCost = "tsadv_LearningBudgetRequestCost",
  course = "tsadv$Course",
  learningType = "tsadv$DicLearningType",
  dicCategory = "tsadv$DicCategory",
  personGroup = "base$PersonGroupExt",
  hotLink = "tsadv$HotLink",
  timeLineComment = "tsadv_TimeLineComment",
  timeLineLike = "tsadv_TimeLineLike",
  learningBudgetAttachment = "tsadv_LearningBudgetAttachment",
  partyEXT = "base$PartyExt",
  dicLearningSubcategory = "tsadv_DicLearningSubcategory",
  jobRequestNote = "tsadv_JobRequestNote",
  learningBudgetHeader = "tsadv_LearningBudgetRequestHeader",
  courseSchedule = "kzm_CourseSchedule",
  assignedGoal = "tsadv$AssignedGoal",
  dicGoalCategory = "tsadv$DicGoalCategory",
  dicGoalLibrary = "tsadv$GoalLibrary",
}
